export const formatCapitalize = (str: string | null | undefined): string =>
    str?.toLowerCase().charAt(0).toUpperCase().concat(str.substring(1).toLowerCase()) || ''
